"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function FormRow(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-row"
  }, props.children);
}

var _default = FormRow;
exports["default"] = _default;